import { ReactNode } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { ContentLoader } from '@frontend/design-system';
import { useStripeElementsOptions, UseStripeElementsOptionsProps } from './hooks';
import { stripeAppearance as appearance } from './utils';

type StripeElementsWrapperProps = UseStripeElementsOptionsProps & {
  children: ReactNode;
};

export const StripeElementsWrapper = ({ children, ...props }: StripeElementsWrapperProps) => {
  const { isLoading, stripeKey, stripePromise, options } = useStripeElementsOptions(props);

  if (isLoading) return <ContentLoader show={true} />;
  return (
    <Elements
      key={stripeKey}
      stripe={stripePromise}
      options={{
        appearance,
        ...options,
      }}
    >
      {children}
    </Elements>
  );
};
